import $ from 'jquery';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { BasePureComponent } from 'components/Base';

/*
 * Ad tracking beacon. As of now it's for Google ads, but it's named generically
 * so we can easily update if PNG ever moves to a different vendor.
 */
class AdTracker extends BasePureComponent {
  constructor(props) {
    // parent, for lifecycle logging
    super(props);

    // for script management
    this.state = {
      ...this.state,
      scriptLoaded: false,
    };
  }

  componentDidMount() {
    // parent, for lifecycle logging
    super.componentDidMount();

    // check if the script is already loaded
    if (!this.state.scriptLoaded) {
      // load the Google Tag Manager script
      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${this.props.id}`;
      if (this.props.options) {
        s.src += '?' + $.param(this.props.options);
      }

      // append it to the DOM
      this.instance.appendChild(s);

      // create the inline script
      const inlineScript = document.createElement('script');
      inlineScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${this.props.id}');
    `;
      this.instance.appendChild(inlineScript);

      // set the script loaded state
      this.setState({ scriptLoaded: true });
    }
  }

  render() {
    // parent, for lifecycle logging
    super.render();

    // render
    return <div ref={(el) => (this.instance = el)} />;
  }
}

// turn this into a container component
export default withRouter(connect()(AdTracker));
